export default class {
	titulo
	idTipoDocumento
	idModeloDocumento
	idAta
	idAditivoApostila
	idPenalidade
	constructor(id, titulo, idTipoDocumento, idDocumentoModelo, idAditivoApostila = null, idPenalidade) {
		this.idAta = id
		this.titulo = titulo
		this.idTipoDocumento = idTipoDocumento
		this.idModeloDocumento = idDocumentoModelo
		this.idAditivoApostila = idAditivoApostila
		this.idPenalidade = idPenalidade
	}
}
